var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:place"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1094 10C11.1039 10 12.0578 9.60491 12.761 8.90165C13.4643 8.19839 13.8594 7.24456 13.8594 6.25C13.8594 5.25544 13.4643 4.30161 12.761 3.59835C12.0578 2.89509 11.1039 2.5 10.1094 2.5C9.11481 2.5 8.16099 2.89509 7.45772 3.59835C6.75446 4.30161 6.35938 5.25544 6.35938 6.25C6.35938 7.24456 6.75446 8.19839 7.45772 8.90165C8.16099 9.60491 9.11481 10 10.1094 10ZM10.1094 11.25C8.78329 11.25 7.51152 10.7232 6.57384 9.78553C5.63616 8.84785 5.10938 7.57608 5.10938 6.25C5.10937 4.92392 5.63616 3.65215 6.57384 2.71447C7.51152 1.77678 8.78329 1.25 10.1094 1.25C11.4355 1.25 12.7072 1.77678 13.6449 2.71447C14.5826 3.65215 15.1094 4.92392 15.1094 6.25C15.1094 7.57608 14.5826 8.84785 13.6449 9.78553C12.7072 10.7232 11.4355 11.25 10.1094 11.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1094 10C10.2751 10 10.4341 10.0658 10.5513 10.1831C10.6685 10.3003 10.7344 10.4592 10.7344 10.625V15.625C10.7344 15.7908 10.6685 15.9497 10.5513 16.0669C10.4341 16.1842 10.2751 16.25 10.1094 16.25C9.94361 16.25 9.78464 16.1842 9.66743 16.0669C9.55022 15.9497 9.48438 15.7908 9.48438 15.625V10.625C9.48438 10.4592 9.55022 10.3003 9.66743 10.1831C9.78464 10.0658 9.94361 10 10.1094 10Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.60938 12.6777V13.9465C5.37812 14.304 3.85938 15.0765 3.85938 15.6252C3.85938 16.3615 6.59188 17.5002 10.1094 17.5002C13.6269 17.5002 16.3594 16.3615 16.3594 15.6252C16.3594 15.0752 14.8406 14.304 12.6094 13.9465V12.6777C15.5219 13.1065 17.6094 14.2652 17.6094 15.6252C17.6094 17.3502 14.2519 18.7502 10.1094 18.7502C5.96688 18.7502 2.60938 17.3502 2.60938 15.6252C2.60938 14.264 4.69688 13.1065 7.60938 12.6777Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnSite);
export default __webpack_public_path__ + "static/media/on_site.c8f33f78ecccdd756895fb4baee6b7c0.svg";
export { ForwardRef as ReactComponent };